import React from "react";
import "./PhotoList.scss";
import ReusableSpinner from "../ReactTable/ReusableSpinner";

const PhotoList = ({
  eventImages = [],
  eventVideos = [],
  eventLinks = [],
  onPreview,
  hasUploadAccess,
  photosLoading,
  isLoading,
  onAddClick
}) => {

  const hasMedia =
    eventImages.length > 0 ||
    eventVideos.length > 0;

  return (
    <div className="media-wrapper">

      {photosLoading || isLoading ? (
        <ReusableSpinner />
      ) : !hasMedia && !hasUploadAccess ? (
        <div className="empty-photos">
          No media available.
        </div>
      ) : (
        <div>
          {/* ================= MEDIA GRID ================= */}
          <div className="media-grid">

            {/* IMAGES */}
            {eventImages.map((image, index) => (
              <div key={image.id} className="media-card">
                <img
                  src={image.url}
                  alt={image.alt || ""}
                  className="media-img"
                  onClick={() => onPreview && onPreview(index)}
                />
              </div>
            ))}

 {/* VIDEOS */}
{eventVideos.map((video) => {

  return (
    <div key={video.id} className="media-card">

      {video.isValid ? (

        <div className="video-thumb">
          <iframe
            src={video.url}
            title={video.title}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          />
        </div>

      ) : (

        <div className="invalid-video">
          <div className="invalid-text">
            Invalid YouTube URL
          </div>
        </div>

      )}

    </div>
  );

})}

            {/* ADD CARD */}
            {hasUploadAccess && (
              <div
                className="media-card add-card"
                onClick={onAddClick}
              >
                <div className="add-inner">
                  +
                </div>
              </div>
            )}

          </div>

          {/* ================= LINKS ================= */}
          {eventLinks.length > 0 && (
            <div className="links-section">
              {eventLinks.map((link) => (
                <div key={link.id} className="event-link-line">
                  <span
                    className="green-click-link"
                    onClick={() => window.open(link.url, "_blank")}
                  >
                    {link.clickableText}
                  </span>

                  <span className="link-description">
                    {" "}{link.description}
                  </span>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default PhotoList;